import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";
import Pager from "@/components/Pager";

const LIMIT = 25;

export default function AdminAudit() {
  const [data, setData] = useState(null);
  const [skip, setSkip] = useState(0);

  const load = useCallback(() => {
    api.get(`/admin/audit-logs?skip=${skip}&limit=${LIMIT}`).then((r) => setData(r.data.data));
  }, [skip]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-6">
      <h1 className="font-display font-black text-3xl tracking-tight">Audit Logs</h1>
      <div className="rounded-2xl border border-border bg-background overflow-hidden overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-secondary/60 text-muted-foreground"><tr>
            {["Admin", "Action", "Entity", "IP", "Time"].map((h) => <th key={h} className="text-left font-semibold px-4 py-3 whitespace-nowrap">{h}</th>)}
          </tr></thead>
          <tbody>
            {data === null ? <tr><td colSpan={5} className="py-16 text-center"><Loader2 className="w-6 h-6 animate-spin mx-auto text-muted-foreground" /></td></tr> :
              data.items.length === 0 ? <tr><td colSpan={5} className="py-16 text-center text-muted-foreground">No actions logged yet.</td></tr> :
              data.items.map((l) => (
                <tr key={l.id} className="border-t border-border" data-testid="audit-row">
                  <td className="px-4 py-3 whitespace-nowrap">{l.admin_email}</td>
                  <td className="px-4 py-3 font-semibold">{l.action}</td>
                  <td className="px-4 py-3 text-muted-foreground">{l.entity_type}</td>
                  <td className="px-4 py-3 text-muted-foreground font-mono text-xs">{l.ip_address}</td>
                  <td className="px-4 py-3 text-muted-foreground whitespace-nowrap">{new Date(l.created_at).toLocaleString()}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      {data && <Pager skip={skip} limit={LIMIT} total={data.total} onPage={setSkip} />}
    </div>
  );
}
